import { render, staticRenderFns } from "./SubmenuTable.vue?vue&type=template&id=cdb44dd4"
import script from "./SubmenuTable.vue?vue&type=script&lang=js"
export * from "./SubmenuTable.vue?vue&type=script&lang=js"
import style0 from "./SubmenuTable.vue?vue&type=style&index=0&id=cdb44dd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports